import React from "react";
import { Typography, makeStyles, Theme, createStyles } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            color: theme.palette.primary.contrastText,
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(1)
            }
        },
        emphasizedText: {
            color: theme.palette.secondary.light,
            fontWeight: 900
        },
    }),
);

const CausePickerTitle = observer(() => {

    const classes = useStyles();

    return (
        <div className={classes.header}>
            <Typography variant="h4">Join the <span className={classes.emphasizedText}>charge </span>that moves you.</Typography>
            {/* <Typography variant="h4">Lend your <span className={classes.emphasizedText}>energy</span> to a great cause.</Typography> */}
        </div>
    )
});

export default CausePickerTitle;